import { render } from "./StoreExportButton.vue?vue&type=template&id=5bc7a122"
import script from "./StoreExportButton.vue?vue&type=script&lang=js"
export * from "./StoreExportButton.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "./StoreExportButton.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Ftmp%2Fbuild_09d06e80%2Fpackages%2Finsurer%2Fsrc%2Fcomponents%2Fstores%2FStoreExportButton.vue&external"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__